'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import Image from 'next/image'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const cards = [
	{
		svg: '/images/outstaffing/reserve_1.svg',
		title: 'Fullstack-разработчики',
		description: 'Универсальные разработчика полного цикла: закрывают задачи как Frontend, так и Backend.'
	},
	{
		svg: '/images/outstaffing/reserve_2.svg',
		title: 'Backend-разработчики',
		description: 'Отвечают за серверную часть системы, базу данных, безопасность и производительность.'
	},
	{
		svg: '/images/outstaffing/reserve_3.svg',
		title: 'Frontend-разработчики',
		description: 'Разрабатывают код для визуальной и интерактивной части сайта или веб‑приложения.'
	},
	{
		svg: '/images/outstaffing/reserve_4.svg',
		title: 'UX/UI-дизайнеры',
		description: 'Проектирует дизайн интерфейса, ориентированный под запросы и привычки пользователей.'
	},
	{
		svg: '/images/outstaffing/reserve_5.svg',
		title: 'Графические дизайнеры',
		description: 'Разрабатывает визуальные концепции и макеты для цифровых и печатных материалов.'
	},
	{
		svg: '/images/outstaffing/reserve_6.svg',
		title: 'SEO-специалисты',
		description: 'Настраивает Яндекс Метрику, ведёт рекламные кампании и продвигает сайт в поиске.'
	},
	{
		svg: '/images/outstaffing/reserve_7.svg',
		title: 'Тестировщики (QA)',
		description: 'Проверяет продукт на всех этапах разработки, находит ошибки и следит за качеством перед запуском.'
	},
	{
		svg: '/images/outstaffing/reserve_8.svg',
		title: 'Менеджеры продукта',
		description: 'Управляет задачами продукта: формирует требования, расставляет приоритеты и координирует команду.'
	},
	{
		svg: '/images/outstaffing/reserve_9.svg',
		title: 'Архитектор ПО',
		description: 'Проектирует структуру системы так, чтобы она выдерживала нагрузку и масштабировалась'
	}
]

const Reserve: React.FC = () => {
	return (
		<section className={styles.reserve}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.subtitle}>Кто в резерве</div>
				<h2 className={styles.title} dangerouslySetInnerHTML={{ __html: '<span>Широкий спектр специалистов</span> любого уровня в резерве' }} />
			</AnimatedSection>
			<div className={styles.cardsGrid}>
				{cards.map(card => (
					<AnimatedSection key={card.title} animation='slideUp' className={styles.cardItem}>
						<article className={styles.card}>
							<div className={styles.cardIcon}>
								<Image src={card.svg} alt={card.title} width={40} height={40} />
							</div>
							<Typography variant='h4' className={styles.cardTitle}>
								{card.title}
							</Typography>
							<Typography variant='p1' color='description' className={styles.cardDescription}>
								{card.description}
							</Typography>
						</article>
					</AnimatedSection>
				))}
			</div>
		</section>
	)
}

Reserve.displayName = 'Reserve'

export default Reserve
